import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  addProduct,
  getAllBrandsList,
  getAllCategory,
  getAllCategoryNoLimit,
  getAllProducts,
  getAllProductsWithoutPagination,
  getSubcategories,
} from "../../../redux/features/assetManagementSlice";
import { debounce } from "lodash";
import Loader3D from "../../../components/Loader/Loader3D";
import AddBrand from "../brand/AddBrand";
const AddProduct = ({ dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [subCat, setSubcat] = useState();

  const { loading, categoryAllData, brandDataList, subCategoryData } =
    useSelector((state) => state.assetmanagement);
  const debouncedFetchData = debounce(() => {
    dispatch(getAllCategoryNoLimit());
    dispatch(getAllBrandsList());
  }, 40);

  useEffect(() => {
    if (open) {
      debouncedFetchData();
    }
  }, [open]);

  const ValidationSchema = Yup.object().shape({
    product_name: Yup.string().required("Please add proudct name"),
    // minimum_stock_quantity: Yup.string().required(
    //   "Minimum Quantity is Required"
    // ),
    brand_id: Yup.string().required("Select Brand"),
    category_id: Yup.string().required("Select Category"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      product_name: "",
      stock_quantity: 1,
      purchase_price: "",
      sale_price: "",
      description: "",
      brand_id: "",
      category_id: "",
      minimum_stock_quantity: null,
      product_serial_number: "",
      sub_category_id: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(addProduct({ data: [values] })).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          if (!dispatchParams) {
            dispatch(getAllProductsWithoutPagination());
          }
          dispatch(getAllProducts(dispatchParams));
          setOpen(false);
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getSubcategories(subCat));
    }
  }, [open, subCat]);

  return (
    <GlobalDialog
      title={"Add Product"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <AddButton size="medium" action={() => setOpen(true)}>
          Add Product
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              {loading && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "rgba(255,255,255,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 10,
                  }}
                >
                  <Loader3D />
                </Box>
              )}
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="product_name"
                    value={formik.values.product_name}
                    error={
                      formik.touched.product_name &&
                      Boolean(formik.errors.product_name)
                    }
                    helperText={formik.errors.product_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Product Name"
                  />

                  {/* <TextField
                    name="minimum_stock_quantity"
                    value={formik.values.minimum_stock_quantity}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Minimum Stock Quantity"
                    error={
                      formik.touched.minimum_stock_quantity &&
                      Boolean(formik.errors.minimum_stock_quantity)
                    }
                    helperText={formik.errors.minimum_stock_quantity}
                  /> */}
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "category_id",
                      label: "Category",
                      data: categoryAllData.data,
                      keys: {
                        id: "category_id",
                        value: "category_name",
                      },
                    }}
                    onChange={(selectedValue) => setSubcat(selectedValue)}
                  />
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "sub_category_id",
                      label: "Sub Category",
                      data: subCategoryData,
                      keys: {
                        id: "sub_category_id",
                        value: "sub_category_name",
                      },
                    }}
                  />
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
                  >
                    <AddBrand />
                  </Box>
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "brand_id",
                      label: "Brand",
                      data: brandDataList.data,
                      keys: {
                        id: "brand_id",
                        value: "brand_name",
                      },
                    }}
                  />
                  <TextField
                    name="description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Description"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddProduct;
